import React from "react";
import { ArrowBackCircle, AddCircleOutline, KeyOutline, LogOutOutline, ListSharp, ExpandOutline, CalendarOutline  } from 'react-ionicons'
import stylesASAP from "./stylesASAP"
import { Modal } from 'react-bootstrap';

export default class List extends React.Component {

    Schedule = () => {
        localStorage.setItem('isSchedule', JSON.stringify(1));
        this.props.history.push("./Client");
    }

    routing = () => {
        localStorage.setItem('isSchedule', JSON.stringify(0));
        this.props.history.push("./Client");
    }

    render() {
        return (
            <div className="container-fluid" style={stylesASAP.mainContainer}>
                <div className="pt-3">
                    <ArrowBackCircle className="btn" onClick={() => this.props.history.push("./LandingPage")}
                        color={'#00bfff'}
                        height="50px"
                        width="50px"
                    />
                </div>
                <div className="d-flex flex-row pt-5" >

                    <div className="btn card flex-fill text-center bg-light pt-3" style={stylesASAP.mainContainer} onClick={() => this.routing()}>
                        <ListSharp className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                        <p className="card-text" style={stylesASAP.itemName}>List Of Clients</p>
                    </div>
                </div>

                    <div className="col-sm-1"></div>
                    <div className="d-flex flex-row pt-5" >
                    <div className="btn card flex-fill text-center bg-light pt-3" style={stylesASAP.mainContainer} onClick={() => this.props.history.push("/ClientAdd")}>
                        <AddCircleOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                        <p className="card-text" style={stylesASAP.itemName}>Add Client</p>
                    </div>

                </div>
                <div className="d-flex flex-row pt-5" >

                    <div className="btn card flex-fill text-center bg-light pt-3 invisible" style={stylesASAP.mainContainer} onClick={() => this.props.history.push("/ClientAdd")}>
                        <AddCircleOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                        <p className="card-text" style={stylesASAP.itemName}>Add Client</p>
                    </div>
                </div>

                {/*invisible*/}
                <div className="d-flex flex-row pt-5">
                    <div className="btn card flex-fill text-center bg-light pt-3 invisible">
                        <LogOutOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                        <p className="card-text" style={stylesASAP.itemName}>Logout</p>
                    </div>

                    <div className="col-sm-1"></div>

                    <div className="btn card flex-fill text-center bg-light pt-3 invisible">
                        <LogOutOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                        <p className="card-text" style={stylesASAP.itemName}>Logout</p>
                    </div>

                </div>
            </div>
        );
    }
}

